"use strict";
import Api from "../../api/api";
var labels = function() {
  return _.map(accountLabels(), function(label) {
    return label.name;
  });
};
var uniqueLabels = function(carriers) {
  return _.chain(carriers).pluck("labels").flatten().uniq().compact().value();
};
var accountLabels = function() {
  return Api.Account.current().labels;
};
export { uniqueLabels };
export default {
  LABELS: labels,
  uniqueLabels
};
